(() => {
  'use strict';
  // GREMARI v13: native MiniCart in scripts.js is the sole owner.
  window.GremariMiniCartV13Native = true;
})();
